import { AccordionItemStyled } from 'modules/mainmenu/responses/styles'
import { AccordionItemButton, AccordionItemHeading, AccordionItemPanel, AccordionItemState } from 'react-accessible-accordion'
import { ReactComponent as ExpandedOff } from 'assets/images/icons/expander_off.svg'
import { ReactComponent as ExpandedOn } from 'assets/images/icons/expander_on.svg'
import PagesList from './PagesList'
import { ReactComponent as PinSvg } from 'assets/images/icons/push_pin.svg'
import { connect } from 'react-redux'

export function Pinned(props) {
  const { favorites, searchText, preExpanded } = props
  return (
    <>
      {(!searchText || (searchText && preExpanded.includes('pinned'))) && (
        <AccordionItemStyled uuid={`pinned`} className={`categorySection accordionItem`} level={0}>
          <AccordionItemHeading className='accordionItemHeading'>
            <AccordionItemButton className='accordionItemButton d-flex justify-content-between'>
              <div className='categoryName-wrapper'>
                <AccordionItemState>
                  {({ expanded }) =>
                    expanded ? (
                      <div className='expandButton expanded'>
                        <ExpandedOn />
                      </div>
                    ) : (
                      <div className='expandButton'>
                        <ExpandedOff />
                      </div>
                    )
                  }
                </AccordionItemState>
                <span className='categoryName ml-1 mr-3' onClick={(e) => e.stopPropagation()}>
                  <PinSvg />
                  <span className='ml-2'>Pinned (for you)</span>
                </span>
              </div>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className={`AccordionItemPanel pages`}>
            {favorites && favorites.length > 0 && <PagesList showMovetocategory={true} section='pinned' pages={favorites} level={1} isFavourite={true} />}
          </AccordionItemPanel>
        </AccordionItemStyled>
      )}
    </>
  )
}

const mapDispatchToProps = () => ({})
const mapStateToProps = () => ({})
export default connect(mapStateToProps, mapDispatchToProps)(Pinned)
